export const TERMS_TITLE = 'Términos y Condiciones de Uso de Sthenus';

export const TERMS_LAST_UPDATED = '16 de junio de 2026';

export const TERMS_HTML = `
<div class="legal-content">
  <p class="legal-text">Última actualización: ${TERMS_LAST_UPDATED}</p>

  <h2 class="legal-subtitle">Aceptación de los Términos</h2>
  <p>Al descargar, instalar, acceder o utilizar la aplicación Sthenus (en adelante, la "Aplicación"), el usuario acepta quedar obligado por los presentes Términos y Condiciones de Uso. Si no está de acuerdo con cualquiera de estas disposiciones, deberá abstenerse de utilizar la Aplicación.</p>

  <h2 class="legal-subtitle">Descripción del Servicio</h2>
  <p>Sthenus es una plataforma digital de fitness que permite a los usuarios acceder a rutinas de ejercicio, programas personalizados de entrenamiento, seguimiento de progreso y contenido relacionado con actividad física y bienestar.</p>
  <p>La Aplicación está destinada a personas mayores de 13 años.</p>

  <h2 class="legal-subtitle">Registro del Usuario</h2>
  <p>Para acceder a determinadas funcionalidades, el usuario deberá crear una cuenta proporcionando información veraz, actualizada y completa.</p>
  <p>El usuario es responsable de:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Mantener la confidencialidad de sus credenciales.</li>
    <li class="legal-list-item">• Todas las actividades realizadas desde su cuenta.</li>
    <li class="legal-list-item">• Notificar inmediatamente cualquier uso no autorizado.</li>
  </ul>
  <p>Sthenus podrá suspender o cancelar cuentas que incumplan estos términos.</p>

  <h2 class="legal-subtitle">Suscripciones y Pagos</h2>
  <p>Sthenus ofrece planes de suscripción mensual y anual.</p>
  <p>Las suscripciones:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Se cobran por adelantado.</li>
    <li class="legal-list-item">• Se renuevan automáticamente salvo cancelación previa.</li>
    <li class="legal-list-item">• Pueden gestionarse desde la App Store, Google Play o el sitio web correspondiente.</li>
  </ul>
  <p>Los precios podrán modificarse previo aviso al usuario.</p>

  <h2 class="legal-subtitle">Salud y Responsabilidad del Usuario</h2>
  <p>El usuario reconoce que la práctica de actividad física implica riesgos inherentes. Antes de iniciar cualquier rutina de entrenamiento, se recomienda consultar a un médico o profesional de la salud.</p>
  <p>El usuario declara que participa voluntariamente en las actividades propuestas por la Aplicación y asume cualquier riesgo derivado de su práctica.</p>

  <h2 class="legal-subtitle">Propiedad Intelectual</h2>
  <p>Todos los contenidos disponibles en Sthenus, incluyendo:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Diseño</li>
    <li class="legal-list-item">• Software</li>
    <li class="legal-list-item">• Logotipos</li>
    <li class="legal-list-item">• Marcas</li>
    <li class="legal-list-item">• Fotografías</li>
    <li class="legal-list-item">• Videos</li>
    <li class="legal-list-item">• Rutinas</li>
    <li class="legal-list-item">• Textos</li>
  </ul>
  <p>son propiedad exclusiva de Sthenus o de sus licenciantes y están protegidos por las leyes de propiedad intelectual aplicables.</p>
  <p>Queda prohibida su reproducción, distribución o explotación sin autorización previa y por escrito.</p>

  <h2 class="legal-subtitle">Conducta Permitida</h2>
  <p>El usuario se compromete a no:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Compartir credenciales.</li>
    <li class="legal-list-item">• Intentar vulnerar la seguridad de la plataforma.</li>
    <li class="legal-list-item">• Utilizar la aplicación para fines ilícitos.</li>
    <li class="legal-list-item">• Copiar o distribuir contenido protegido.</li>
    <li class="legal-list-item">• Realizar ingeniería inversa del software.</li>
  </ul>

  <h2 class="legal-subtitle">Exención de Responsabilidad</h2>
  <p>La Aplicación se proporciona "tal cual" y "según disponibilidad".</p>
  <p>Sthenus no garantiza:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Resultados físicos específicos.</li>
    <li class="legal-list-item">• Disponibilidad ininterrumpida.</li>
    <li class="legal-list-item">• Ausencia total de errores.</li>
  </ul>
  <p>Sthenus no será responsable por:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Lesiones derivadas de la realización de ejercicios.</li>
    <li class="legal-list-item">• Pérdidas económicas.</li>
    <li class="legal-list-item">• Daños indirectos o consecuenciales.</li>
    <li class="legal-list-item">• Interrupciones del servicio por causas ajenas.</li>
  </ul>

  <h2 class="legal-subtitle">Modificaciones y Actualizaciones</h2>
  <p>Sthenus podrá modificar:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Funcionalidades.</li>
    <li class="legal-list-item">• Contenido.</li>
    <li class="legal-list-item">• Tarifas.</li>
    <li class="legal-list-item">• Términos y Condiciones.</li>
  </ul>
  <p>Las modificaciones entrarán en vigor una vez publicadas dentro de la Aplicación o en los medios oficiales.</p>

  <h2 class="legal-subtitle">Terminación</h2>
  <p>Sthenus podrá suspender o cancelar cuentas que incumplan estos términos.</p>
  <p>El usuario podrá dejar de utilizar la Aplicación en cualquier momento.</p>

  <h2 class="legal-subtitle">Protección de Datos</h2>
  <p>El tratamiento de datos personales se regula mediante la Política de Privacidad de Sthenus.</p>

  <h2 class="legal-subtitle">Legislación Aplicable y Jurisdicción</h2>
  <p>Estos términos se regirán por las leyes de los Estados Unidos Mexicanos.</p>
  <p>Cualquier controversia será sometida a los tribunales competentes de Cd Monterrey, Nuevo León, México, renunciando las partes a cualquier otro fuero que pudiera corresponderles.</p>

  <h2 class="legal-subtitle">Política de Cancelación y Reembolsos</h2>

  <h3 class="legal-text">Cancelación de Suscripciones</h3>
  <p>Los usuarios podrán cancelar su suscripción en cualquier momento.</p>
  <p>La cancelación evitará renovaciones futuras, pero no genera reembolsos automáticos de períodos ya facturados.</p>

  <h3 class="legal-text">Compras realizadas en App Store</h3>
  <p>Las solicitudes de reembolso deberán realizarse directamente ante Apple conforme a sus políticas vigentes.</p>

  <h3 class="legal-text">Compras realizadas en Google Play</h3>
  <p>Las solicitudes de reembolso deberán gestionarse directamente con Google conforme a las políticas de Google Play.</p>

  <h3 class="legal-text">Compras realizadas directamente con Sthenus</h3>
  <p>Sthenus podrá evaluar solicitudes de reembolso cuando:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Exista un cobro duplicado.</li>
    <li class="legal-list-item">• Existan errores técnicos atribuibles a la plataforma.</li>
    <li class="legal-list-item">• El servicio contratado no haya podido utilizarse por causas imputables a Sthenus.</li>
  </ul>
  <p>No se realizarán reembolsos por:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Falta de uso.</li>
    <li class="legal-list-item">• Cambio de opinión.</li>
    <li class="legal-list-item">• Resultados físicos no alcanzados.</li>
  </ul>

  <h3 class="legal-text">Tiempo de Resolución</h3>
  <p>Las solicitudes serán evaluadas en un plazo máximo de 15 días hábiles.</p>

  <h2 class="legal-subtitle">Política de Prevención de Fraude y Términos para Tiendas</h2>

  <h3 class="legal-text">Prevención de Fraude</h3>
  <p>Sthenus implementa mecanismos de seguridad para detectar:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Accesos sospechosos.</li>
    <li class="legal-list-item">• Compartición indebida de cuentas.</li>
    <li class="legal-list-item">• Uso de métodos de pago fraudulentos.</li>
    <li class="legal-list-item">• Actividades automatizadas o maliciosas.</li>
  </ul>
  <p>La empresa podrá:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Suspender temporalmente cuentas.</li>
    <li class="legal-list-item">• Solicitar validación de identidad.</li>
    <li class="legal-list-item">• Cancelar suscripciones asociadas a actividades fraudulentas.</li>
  </ul>

  <h3 class="legal-text">Términos Específicos para App Store y Google Play</h3>
  <p>Cuando la Aplicación sea descargada desde Apple App Store o Google Play Store:</p>
  <ol class="legal-list">
    <li class="legal-list-item">1. Apple y Google no son responsables del funcionamiento de la Aplicación.</li>
    <li class="legal-list-item">2. La licencia otorgada es personal, limitada, revocable y no transferible.</li>
    <li class="legal-list-item">3. Todas las reclamaciones relacionadas con la Aplicación deberán dirigirse a Sthenus.</li>
    <li class="legal-list-item">4. El usuario deberá cumplir los términos de uso de la tienda correspondiente.</li>
    <li class="legal-list-item">5. Apple y Google son terceros beneficiarios de estos términos y podrán hacerlos valer cuando corresponda.</li>
  </ol>

  <h2 class="legal-subtitle">Contrato para Comercios Afiliados</h2>
  <p>Los comercios, gimnasios, entrenadores o aliados comerciales que participen en programas de afiliación con Sthenus deberán:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Mantener información veraz y actualizada.</li>
    <li class="legal-list-item">• Respetar la propiedad intelectual de Sthenus.</li>
    <li class="legal-list-item">• Cumplir las leyes de protección al consumidor aplicables.</li>
    <li class="legal-list-item">• No realizar publicidad engañosa.</li>
  </ul>
  <p>Sthenus podrá finalizar la relación comercial de forma inmediata ante incumplimientos.</p>

  <h2 class="legal-subtitle">Versión Simplificada para Usuarios</h2>
  <p>Al utilizar Sthenus aceptas que:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Usas la aplicación bajo tu propia responsabilidad.</li>
    <li class="legal-list-item">• Debes consultar a un médico antes de iniciar ejercicios si tienes dudas sobre tu condición física.</li>
    <li class="legal-list-item">• Tu suscripción se renovará automáticamente hasta que la canceles.</li>
    <li class="legal-list-item">• No puedes compartir tu cuenta con otras personas.</li>
    <li class="legal-list-item">• Todo el contenido de Sthenus está protegido por derechos de autor.</li>
    <li class="legal-list-item">• Podemos actualizar la aplicación y estos términos cuando sea necesario.</li>
    <li class="legal-list-item">• Las compras realizadas mediante App Store o Google Play se rigen también por las políticas de dichas plataformas.</li>
  </ul>
</div>
`;
